(function () {
  'use strict';

  angular.module('wsLrs.controllers').service('ExplorePermissionSvc', ['$rootScope', function ($rootScope) {
    $rootScope.$on('organization-selected', function () {
      self.exploreGroups = [];
      self.explorePeople = [];
      self.explorePermissions = [];
    });
    var self = {
      exploreGroups: [],
      explorePeople: [],
      explorePermissions: [],
      get: function get() {
        return {
          permissions: self.getPermissions(),
          people: self.getPeople(),
          groups: self.getGroups(),
          hasGlobalGroup: self.getHasGlobalGroup()
        };
      },
      getPermissions: function getPermissions() {
        return self.explorePermissions;
      },
      getPeople: function getPeople() {
        return self.explorePeople;
      },
      getGroups: function getGroups() {
        return self.exploreGroups;
      },
      getHasGlobalGroup: function getHasGlobalGroup() {
        return !_.isUndefined(_.find(self.getGroups(), function (g) {
          return g.id === -1;
        }));
      },
      set: function set(permissions, people, groups) {
        if (_.isArray(permissions)) {
          self.explorePermissions = permissions;
        }
        if (_.isArray(people)) {
          self.explorePeople = _.sortBy(people, 'name');
        }
        if (_.isArray(groups)) {
          self.exploreGroups = _.sortBy(groups, 'name');
        }
      },
      setAll: function setAll(explorePermissions) {
        if (_.isObject(explorePermissions)) {
          self.set(explorePermissions.permissions, explorePermissions.people, explorePermissions.groups);
        }
      }
    };
    return self;
  }]).config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/explore-access', {
      templateUrl: 'modules/app/settings/explore-access/explore-access.html',
      controller: 'ExploreAccessCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('ExploreAccessCtrl', ['$scope', "$uibModal", "AppPermissions", "ExplorePermissionSvc", 'OrganizationSettings', 'User', '$http', 'Api', '$rootScope', 'Logger', function ($scope, $uibModal, AppPermissions, PermissionSvc, OrganizationSettings, User, $http, Api, $rootScope, Logger) {
    $scope.$emit("headline:change", "Settings");
    $scope.$emit("nav:change", "settings");
    $scope.section = "explore-access";
    $scope.permissionsLoaded = false;
    AppPermissions.getPermissions('explorer').then(function (result) {
      var explorePermissions = result.explorer;
      PermissionSvc.setAll(explorePermissions);
      $scope.explorePermissions = PermissionSvc.get();
      $scope.permissionsLoaded = true;
    });

    // For Org Settings
    var orgId = User.get().organization.id;
    $http.get(Api.url("/organizations/" + orgId + "/settings", true)).then(function getOrgSettingsSuccess(response) {
      $scope.orgSettings = response.data;
    });
    $scope.saveOrgSettings = function () {
      $http.put(Api.url("/organizations/" + orgId + "/settings", true), $scope.orgSettings).then(function () {
        $rootScope.$emit("organization-settings-updated", $scope.orgSettings);
      }, function saveOrgSettingsError(response) {
        Logger.error("Error saving organization settings for org " + orgId + ", response status " + response.status);
      });
    };
    $scope.addPermission = function addPermission(target) {
      if (_.has(target, 'childGroupIds')) {
        $scope.explorePermissions.groups.push(target);
        $scope.explorePermissions.permissions.push({
          value: 'explorer',
          groupId: target.id
        });
      } else {
        $scope.explorePermissions.people.push(target);
        $scope.explorePermissions.permissions.push({
          value: 'explorer',
          personId: target.id
        });
      }
      $scope.save();
    };
    $scope.removePermission = function removePermission(target) {
      if (_.has(target, 'childGroupIds')) {
        $scope.explorePermissions.groups = _.reject($scope.explorePermissions.groups, function (o) {
          return o.id === target.id;
        });
        $scope.explorePermissions.permissions = _.reject($scope.explorePermissions.permissions, function (p) {
          return p.groupId === target.id;
        });
      } else {
        $scope.explorePermissions.people = _.reject($scope.explorePermissions.people, function (o) {
          return o.id === target.id;
        });
        $scope.explorePermissions.permissions = _.reject($scope.explorePermissions.permissions, function (p) {
          return p.personId === target.id;
        });
      }
      $scope.save();
    };
    $scope.save = function save() {
      if ($scope.clearPersonOrGroup) {
        $scope.clearPersonOrGroup();
      }
      $scope.saveExploreAccessError = null;
      $scope.saveExploreAccessProgress = "Updating report builder access permissions...";
      $scope.sending = true;
      AppPermissions.multiSave($scope.explorePermissions.permissions, {
        params: {
          value: 'explorer',
          _limit: 1000
        }
      }).then(function saveExploreAccessSuccess() {
        $scope.sending = false;
        $scope.saveExploreAccessProgress = null;
      }, function saveExploreAccessError(response) {
        $scope.saveExploreAccessProgress = null;
        Logger.error("Error updating report builder access permissions, response status " + response.status);
        $scope.saveExploreAccessError = "There was error updating report builder access permissions.";
        $scope.sending = false;
      });
    };
  }]);
})();
